package sarka.design.skoria.ui.composables

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Card
import androidx.compose.material3.CardColors
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.ui.tooling.preview.Preview
import sarka.design.skoria.ui.theme.RCTheme
import skoria.composeapp.generated.resources.Res
import skoria.composeapp.generated.resources.skoria_logo

@Composable
fun HomeButton(
    modifier: Modifier = Modifier,
    titleText: String,
    illustration: DrawableResource,
    onCardClick: () -> Unit,
) {
    Box(
        modifier = modifier.padding(8.dp),
    ) {
        Card(
            onClick = { onCardClick() },
            colors = CardColors(
                containerColor = Color.Transparent,
                contentColor = RCTheme.colors.primaryContainer,
                disabledContainerColor = Color.Transparent,
                disabledContentColor = Color.Transparent
            )
        ) {
            val colorStart = RCTheme.colors.onPrimaryContainer
            val colorMid = RCTheme.colors.onSurface
            val colorEnd = RCTheme.colors.scrim
            Column(
                modifier = Modifier
                    .size(96.dp)
                    .clip(CardDefaults.shape)
                    .drawBehind {
                        val w = size.width
                        val h = size.height
                        val brush = Brush.radialGradient(
                            colors = listOf(colorStart, colorMid, colorEnd),
                            center = Offset(w * 0.1f, h * 0.3f),
                            radius = maxOf(w, h) * 1.4f
                        )
                        drawRect(brush)
                    },
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center
            ) {
                Image(
                    painter = painterResource(illustration),
                    contentDescription = "Skoria",
                    modifier = Modifier
                        .size(64.dp)
                )
            }
            Text(text = titleText, modifier = Modifier.align(Alignment.CenterHorizontally), color = RCTheme.colors.onSurface)
        }
    }

}

@Composable
@Preview
fun HomeButtonPreview() {
    RCTheme {
        Row {
            HomeButton(
                titleText = "Video Chat",
                illustration = Res.drawable.skoria_logo,
                onCardClick = {}
            )
            HomeButton(
                titleText = "Video Chat",
                illustration = Res.drawable.skoria_logo,
                onCardClick = {}
            )
            HomeButton(
                titleText = "Video Chat",
                illustration = Res.drawable.skoria_logo,
                onCardClick = {}
            )
        }
    }
}